import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';
import Invoice from '../organisms/Invoice';

//Returning the component
class DashboardInvoice extends Component {
	render() {
		return (
			<div className="dashboardBody">
				<DashboardNavigation />
				<div className="dashboardMainContent">
					<div className="container">
						<Invoice />
					</div>
				</div>
			</div>
		)
	}
}

export default DashboardInvoice;


// WEBPACK FOOTER //
// ./src/redux/components/templates/DashboardInvoice.jsx